import { useEffect, useState } from "react";
import {
  PasoBarCirculo,
  
  PasoBarCirculoActivo,
  
  PasoBarCirculoCompleto,
  
  PasoBarContainer,
  PasoBarLinea,
  PasoBarLineaProgreso,
} from "./LocalStyle";

const PasoBar = ({ paso }) => {
  const [arrayCirculos, setArrayCirculos] = useState([
    { completado: false, activo: false },
    { completado: false, activo: false },
    { completado: false, activo: false },
    { completado: false, activo: false },
  ]);

  const cambiarPaso = (pasoActual) => {
    switch (pasoActual) {
      case "MedicoSolicitante":
        setArrayCirculos([
          { completado: false, activo: true },
          { completado: false, activo: false },
          { completado: false, activo: false },
          { completado: false, activo: false },
        ]);
        break;
      case "SubirOrden":
        setArrayCirculos([
          { completado: true, activo: false },
          { completado: false, activo: true },
          { completado: false, activo: false },
          { completado: false, activo: false },
        ]);
        break;
      case "AbonarMP":
        setArrayCirculos([
          { completado: true, activo: false },
          { completado: true, activo: false },
          { completado: false, activo: true },
          { completado: false, activo: false },
        ]);
        break;
      case "ValidarCobertura":
        setArrayCirculos([
          { completado: true, activo: false },
          { completado: true, activo: false },
          { completado: true, activo: false },
          { completado: false, activo: true },
        ]);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (paso !== null) {
      cambiarPaso(paso);
    }
  }, [paso]);

  return (
    <PasoBarContainer>
      <PasoBarLinea>
        <PasoBarLineaProgreso pasoActual={paso}></PasoBarLineaProgreso>
        {arrayCirculos.length > 0 &&
          arrayCirculos.map((item, index) => {
            return (
              <PasoBarCirculo key={index}>
                {item.completado && (
                  <PasoBarCirculoCompleto></PasoBarCirculoCompleto>
                )}
                {item.activo && (
                  <PasoBarCirculoActivo></PasoBarCirculoActivo>
                )}
              </PasoBarCirculo>
            );
          })}
      </PasoBarLinea>
    </PasoBarContainer>
  );
};

export default PasoBar;
